import { Link } from '@tanstack/react-router'

import { Button } from '@/components/button/button'

export const SubscribeBanner = () => {
  return (
    <div className="flex h-top-banner select-none items-center justify-between overflow-hidden bg-amber-400 px-[100px]">
      <div className="flex items-center gap-4">
        <Warn />
        <div className="text-lg font-medium">
          Realtime notification has been disabled.
          <span className="pl-2.5 text-base font-normal">
            Subscribe to Lawfully Pro to ensure proper update notifications, case registration and more.
          </span>
        </div>
      </div>
      <Link to="/pricing">
        <Button className="bg-black hover:bg-black/85" asChild>
          <div>Subscribe now</div>
        </Button>
      </Link>
    </div>
  )
}
const Warn = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.835 3.75C10.7973 2.08333 13.2029 2.08333 14.1651 3.75L21.8913 17.1322C22.8536 18.7988 21.6508 20.8822 19.7263 20.8822H4.27386C2.34936 20.8822 1.14655 18.7988 2.1088 17.1322L9.835 3.75Z"
        fill="#18181B"
      />
      <path
        d="M11.1339 5.76074C11.5188 5.09408 12.4811 5.09408 12.866 5.76074L19.5 17.2512C19.8849 17.9179 19.4038 18.7512 18.634 18.7512H5.36589C4.59609 18.7512 4.11496 17.9179 4.49987 17.2512L11.1339 5.76074Z"
        fill="black"
      />
      <path
        d="M10.7652 9.37454C10.7399 8.80537 11.1945 8.33008 11.7642 8.33008H12.233C12.8038 8.33008 13.2589 8.80712 13.2319 9.37731L13.0369 13.5002C13.0117 14.0335 12.572 14.453 12.038 14.453H11.9477C11.4128 14.453 10.9725 14.0319 10.9487 13.4974L10.7652 9.37454Z"
        fill="#FBBF24"
      />
      <rect x="10.8914" y="15.4092" width="2.21724" height="2.06395" rx="1" fill="#FBBF24" />
    </svg>
  )
}
